export default __webpack_public_path__ + "static/media/facebook.d5d81547.svg";